import TreeViewModel, { DragMode, DropResult } from "../models/TreeviewModel";
import Logger from "../Logger";
import TopologyLevel from "../models/Line";
import BaseModel from "../models/BaseModel";
import Line from "../models/Line";
import { itx } from "../translationItx/itx";
import { isBetaVersion, isUiModeProductAdmin } from "../uiMode";
import Area from "../models/Area";
import Device from "../models/Device";
import BaseModelReference from "../models/BaseModelReference";

const logger = new Logger();

export default class LineTreeViewModel extends TreeViewModel {
  get typedObj(): Line {
    return this.obj as TopologyLevel;
  }

  get isFolder(): boolean {
    return true;
  }

  get iconUrl(): string | undefined {
    return "las la-grip-horizontal TopologyLevel2";
  }

  getTagNeeded(): boolean {
    return true;
  }

  get childCollection(): Array<BaseModel> | undefined {
    return this.typedObj.getDeviceReferences();
  }

  handleOpen(): boolean {
    if (!isUiModeProductAdmin()) {
      return false;
    }

    if (state.activePanes.isOpen(this.typedObj.id)) {
      state.activePanes.activatePane(this.typedObj.id);
    } else {
      state.activePanes.openPane(this.obj);
      const pane = state.activePanes.getPane(this.typedObj.id);
      if (pane) {
        pane.title = itx("lineTreeViewModel.deviceLineProgramming", "Programmiere Geräte, Line: ") + this.typedObj.tag;

        if (pane.tabItemData) {
          pane.tabItemData.title = pane.title || "";
        }
      }
    }

    return true;
  }

  getButtons(): JSX.Element[] | undefined {
    if (!isUiModeProductAdmin()) {
      this.hasOpenButton = false;
      return undefined;
    }

    if (isBetaVersion()) {
      const res = [super.inlineButton_Open("inlineButton.progDevices", "microchip")]; // no itx "chevron-down", "rss-square",
      return res;
    }
    // add button for open properties
    return [super.inlineButton_Open("inlineButton.progDevices", "microchip")]; // no itx "chevron-down", "rss-square",

    return undefined;
  }
  get contextMenuItems(): any {
    var subLabelPaste = undefined;

    try {
      subLabelPaste = state.contextMenuManager.clipboardData.items[0].name;
    } catch (ex) {
      logger.error(ex);
    }

    return {
      items: [
        this.baseContextMenuItems_Paste(subLabelPaste),
        this.baseContextMenuItems_Copy(),
        this.baseContextMenuItems_Delete(),
      ],
    };
  }

  async handleDrop2(mode: DragMode, obj: BaseModel): Promise<DropResult> {
    if (obj.isDevice) {
      const device = obj as Device;
      const oldFullPhysicalAddress = device.physicalAddress;
      const oldLineAddress = device.lineAddress;
      const oldAreaAddress = device.areaAddress;
      const line = this.typedObj as Line;
      const area = this.typedObj.parent as Area;
      let lineAddress = line.lineNumber;
      let areaAddress = area.areaNumber;
      device.lineAddress = String(lineAddress);
      device.areaAddress = String(areaAddress);
      device.findFreePhysicalAddress();

      device.raiseOnChange("physicalAddress");

      area.raiseOnChange("lines");
      area.raiseOnChange("childCollection");
      line.raiseOnChange("childCollection");
      const oldArea = state.topologies.findFirst((a) => String(a.areaNumber) == oldAreaAddress);
      if (oldArea) {
        const oldLine = oldArea.lines.findFirst((l) => String(l.lineNumber) == oldLineAddress);
        if (oldLine) {
          oldLine.raiseOnChange("childCollection");
        }
        oldArea.raiseOnChange("childCollection");
      }
      return new DropResult(true);
    } else if (obj.className == "BaseModelReference") {
      const refObj = obj as BaseModelReference;
      const referencedObject = refObj.referencedObject;
      if (referencedObject) {
        return this.handleDrop2(mode, referencedObject);
      }
    }
    return await super.handleDrop2(mode, obj);
  }
}
